import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from './client.ts';
import { queryDefaults } from './queries.ts';
import { useSession } from '../auth/session.tsx';
import type { VisitRate, VisitRateInput, VisitRatePolicies } from './types.ts';

/** Visit rates by residence type: current, scheduled and earlier. Tier 1 only. */
export function useVisitRates(enabled: boolean) {
  const { getToken } = useSession();
  return useQuery({
    queryKey: ['policies', 'visit-rates'],
    queryFn: () => apiFetch<VisitRatePolicies>('/policies/visit-rates', getToken),
    ...queryDefaults,
    enabled,
  });
}

/**
 * Record a new visit rate. The server inserts; nothing here can change a rate
 * already on record. A rate in force today changes what clients owe, so the
 * client and dashboard queries are refreshed as well as the policies.
 */
export function useRecordVisitRate() {
  const { getToken } = useSession();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: VisitRateInput) =>
      apiFetch<{ residence_type_label: string; rate: VisitRate }>('/policies/visit-rates', getToken, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(input),
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['policies'] });
      void queryClient.invalidateQueries({ queryKey: ['client'] });
      void queryClient.invalidateQueries({ queryKey: ['dashboards'] });
    },
  });
}
